module.exports = __webpack_public_path__ + "img/buy-mb.ea3da8f3.webp";